export const Themes = {
  listModel: {
    selectItem: title => alert(`Selected: ${title}!`),
    items: [
      {
        uuid: "item-0",
        title: "Mountains",
        subtitle: "7 Names",
        image:
          "https://user-images.githubusercontent.com/3536716/59119038-bc70a080-891f-11e9-94a2-fc2545454823.png"
      },
      {
        uuid: "item-1",
        title: "Big Cats",
        subtitle: "9 Names",
        image:
          "https://user-images.githubusercontent.com/3536716/59119158-11141b80-8920-11e9-8d74-b01e448de7d4.png"
      },
      {
        uuid: "item-2",
        title: "Farms",
        subtitle: "5 Names",
        image:
          "https://user-images.githubusercontent.com/3536716/59119177-183b2980-8920-11e9-9460-a6e29801e8d8.png"
      },
      {
        uuid: "item-3",
        title: "Food",
        subtitle: "4 Names",
        image:
          "https://user-images.githubusercontent.com/3536716/59119190-238e5500-8920-11e9-97fa-5e96dff1c795.png"
      },
      {
        uuid: "item-4",
        title: "Beaches",
        subtitle: "10 Names",
        image:
          "https://user-images.githubusercontent.com/3536716/59119209-2ab56300-8920-11e9-8388-b78c84a7dde0.png"
      },
      {
        uuid: "item-5",
        title: "Deserts",
        subtitle: "7 Names",
        image:
          "https://user-images.githubusercontent.com/3536716/59119216-2ee18080-8920-11e9-92c9-f479bf001003.png"
      }
    ]
  }
};
